import { ethers } from 'ethers'

export function parseABI(abi: string): ethers.utils.Interface {
  const parsedABI = JSON.parse(abi)
  if (parsedABI.abi) {
    return new ethers.utils.Interface(parsedABI.abi)
  }
  return new ethers.utils.Interface(abi)
}
